import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';

export const CarerLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await login({ email: email.trim(), password: password.trim() });
      navigate('/carer/dashboard');
    } catch {
      setError('Invalid email or password. Please try again.');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '40px auto', padding: 32, backgroundColor: '#fff', borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
      <h1 style={{ fontSize: 28, textAlign: 'center', marginBottom: 8 }}>Carer Login</h1>
      <p style={{ textAlign: 'center', color: '#666', marginBottom: 32 }}>Sign in to access the dashboard</p>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="email" style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: '100%', padding: 12, fontSize: 16, border: '1px solid #ddd', borderRadius: 6, boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ marginBottom: 24 }}>
          <label htmlFor="password" style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: 12, fontSize: 16, border: '1px solid #ddd', borderRadius: 6, boxSizing: 'border-box' }}
          />
        </div>
        {error && <p style={{ color: 'red', fontSize: 14, marginBottom: 16 }}>{error}</p>}
        <button type="submit" style={{ width: '100%', padding: 14, fontSize: 18, fontWeight: 600, backgroundColor: '#1976d2', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}>
          Sign In
        </button>
      </form>
    </div>
  );
};